import React from "react";

const PAGINATION_PADDING = 2;

function Pagination({ currentPage, lastPage, onLoadPage }) {
  if (lastPage <= 1) return null;

  const firstPaginationPage = Math.max(currentPage - PAGINATION_PADDING, 2);
  const lastPaginationPage = Math.min(currentPage + PAGINATION_PADDING, lastPage - 1);

  const pages = [];
  for (let i = firstPaginationPage; i <= lastPaginationPage; i++) {
    if (i !== 1 && i !== lastPage) {
      pages.push(i);
    }
  }

  return (
    <ul className="pagination-controls">
      <li
        className="pagination-item"
        data-page="previous"
        onClick={() => currentPage > 1 && onLoadPage("previous")}
      >
        <span className={`btn btn-default chevron-left${currentPage <= 1 ? " disabled" : ""}`} />
      </li>

      <li
        className="pagination-item"
        data-page={1}
        onClick={() => onLoadPage(1)}
      >
        <span className={`btn btn-default${currentPage === 1 ? " active" : ""}`}>1</span>
      </li>

      {firstPaginationPage > 2 && (
        <li className="pagination-item">&hellip;</li>
      )}

      {pages.map((page) => (
        <li
          key={page}
          className="pagination-item"
          data-page={page}
          onClick={() => onLoadPage(page)}
        >
          <span className={`btn btn-default${currentPage === page ? " active" : ""}`}>{page}</span>
        </li>
      ))}

      {lastPaginationPage < lastPage - 1 && (
        <li className="pagination-item">&hellip;</li>
      )}

      {lastPage > 1 && (
        <li
          className="pagination-item"
          data-page={lastPage}
          onClick={() => onLoadPage(lastPage)}
        >
          <span className={`btn btn-default${currentPage === lastPage ? " active" : ""}`}>{lastPage}</span>
        </li>
      )}

      <li
        className="pagination-item"
        data-page="next"
        onClick={() => currentPage < lastPage && onLoadPage("next")}
      >
        <span className={`btn btn-default chevron-right${currentPage >= lastPage ? " disabled" : ""}`} />
      </li>
    </ul>
  );
}

export default Pagination;
